import { SWRConfig } from "swr"

import Signup from '@/src/views/Signup';
import promiseHash from "@/components/promiseHash";
import fetchAPI from "@/components/fetchAPI";

export async function getServerSideProps(context) {
  const data = await promiseHash({
    user: fetchAPI('/api/users/me/', {}, context),
  });

  const { user } = data;

  if (user?.id) {
    return {
      redirect: {
        destination: '/profile/',
        permanent: false,
      }
    }
  }

  return {
    props: {
      fallback: {
        '/api/users/me/': user
      }
    }
  }
}

export default function SignupPage({ fallback }) {
  return (
    <SWRConfig value={{ fallback }}>
      <Signup />
    </SWRConfig>
  );
}
